// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { User } from './user';
import { UserSettingAdmin } from './user-setting-admin';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class UserSetting extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  userSettingId!: number;
  createdBy!: string;
  createdDate!: Date;
  setting?: string;
  settingId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  userId!: number;
  user!: User;
  userSettingAdmins!: UserSettingAdmin[];
}

